import { motion } from "framer-motion";

const STATS = [
  { k: "Legacy systems modernized", v: "40yr+" },
  { k: "Engineering experience", v: "Ex-GS" },
  { k: "Verification layer", v: "Parallel" },
  { k: "Cloud partners", v: "AWS · GCP · Azure" },
];

export default function TrustSection() {
  return (
    <section
      data-testid="trust-section"
      className="relative border-b border-white/10 bg-carbon"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-5">
            <div className="chip text-white/50">// trust_matrix</div>
            <p className="mt-4 text-2xl lg:text-3xl font-display font-bold text-white leading-tight">
              &ldquo;Enterprises don't need another platform. They need someone
              to take <span className="text-neon-green">responsibility</span>{" "}
              for the outcome.&rdquo;
            </p>
            <p className="mt-4 text-sm text-white/50 font-mono">
              — Kuldeep Singh Jangir, Founder · ex-Goldman Sachs engineering
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 gap-px bg-white/10 border border-white/10">
            {STATS.map((s, i) => (
              <motion.div
                key={s.k}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08 }}
                className="bg-obsidian p-8 min-h-[140px]"
                data-testid={`stat-${i}`}
              >
                <div className="font-display font-black text-3xl text-white tracking-tight">
                  {s.v}
                </div>
                <div className="mt-2 chip text-white/50">{s.k}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
